module.exports = __webpack_public_path__ + "img/ae.d8741634.svg";